import { EditFilledIcon } from '@mote/assets/icons'
import type { MoteActionButtonProps } from '../MoteActionButton'
import { MoteActionButton } from '../MoteActionButton'

export interface MoteEditButtonProps
  extends Pick<MoteActionButtonProps, 'textPosition' | 'size'> {
  onClick: () => void
}

export function MoteEditButton(props: MoteEditButtonProps): JSX.Element {
  return (
    <MoteActionButton
      size={props.size}
      text='Edit'
      icon={<EditFilledIcon />}
      id='moteEditButton'
      ariaLabel='Edit'
      textPosition={props.textPosition}
      onClick={props.onClick}
    />
  )
}
